import { useUpdateEffect } from "react-use";
import { Rating, TextArea, TextInput } from "../common/Forms";
import { useEffect, useState } from "react";

export const OptionsAnswerComponent = ({
  name,
  type,
  content,
  index,
  readOnly,
  response,
  onChange,
}) => {
  let idx = 0;
  if (readOnly && !response) {
    idx = 5;
  } else if (response) {
    idx = response;
  }
  return (
    <>
      {(type === "text" || type === "textarea") && (
        <TextArea
          name={name}
          placeholder={content || "답변을 입력하세요."}
          className="w-3/5 p-1 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
          readOnly
        />
      )}
      {type === "rating" && (
        <Rating
          {...{
            length: 10,
            value: idx,
            onChange,
            id: `${type}-${index}`,
            key: `rating_${index}`,
            readOnly,
          }}
        />
      )}
      {(type === "radio" || type === "checkbox") && (
        <div className="flex items-center">
          <input
            id={`${type}-${index}-${content}`}
            name={name}
            type={type}
            className="h-4 w-4 border-zinc-400 bg-white"
            onChange={onChange}
            readOnly={readOnly || false}
          />
          {typeof content === "string" && (
            <label
              htmlFor={name}
              className="ml-3 block text-sm font-medium text-zinc-700"
            >
              {content}
            </label>
          )}
          {typeof content === "object" && (
            <input
              type={content.type}
              placeholder={content.content}
              className="ml-3 w-2/5 rounded border border-solid border-zinc-400 p-1 font-normal placeholder:text-zinc-400 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
              readOnly={readOnly || false}
              onChange={onChange}
            />
          )}
        </div>
      )}
    </>
  );
};

export const InputAnswerComponent = ({ type, placeholder, readOnly }) => {
  return (
    <>
      {type === "text" && (
        <TextInput
          placeholder={placeholder}
          readOnly={readOnly || false}
          className="w-3/5 resize-none rounded border border-solid border-zinc-400 p-1 font-normal placeholder:text-zinc-400 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
        />
      )}
      {type === "textarea" && (
        <TextArea
          placeholder={placeholder}
          readOnly={readOnly || false}
          className="w-3/5 p-1 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
        />
      )}
    </>
  );
};

export const RadioInputGroup = ({ option, onChange, index, value }) => {
  const [selectIndex, setSelect] = useState(-1);
  const [inputObj, setObj] = useState({});
  const handleChange = (j) => (e) => {
    if (selectIndex !== j) {
      delete inputObj[j];
      setSelect(j);
    }
  };

  const handleInputChange = (j) => (e) => {
    setObj({ [j]: e.target.value });
  };

  useUpdateEffect(() => {
    if (selectIndex > -1) {
      if (typeof option[selectIndex].content === "string") {
        onChange(index, option[selectIndex].content);
      } else if (inputObj && selectIndex in inputObj) {
        onChange(index, inputObj[selectIndex]);
      }
    }
  }, [selectIndex, inputObj]);

  useEffect(() => {
    if (value) {
      let idx = option.findIndex(({ content }) => content === value);
      if (idx < 0) {
        idx = option.findIndex(({ content }) => typeof content === "object");
        setObj({ [idx]: value });
      }
      setSelect(idx);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option, value]);

  return (
    <fieldset className="flex flex-col gap-3">
      {option.map(({ content }, j) => (
        <div className="flex items-center" key={`radio-${index}-${j}`}>
          <input
            id={`radio-${index}-${content}`}
            name={`radio-${index}`}
            type="radio"
            className="h-4 w-4 border-zinc-400 bg-white"
            onChange={handleChange(j)}
            checked={selectIndex === j}
          />
          {typeof content === "string" && (
            <label
              htmlFor={`$radio-${index}`}
              className="ml-3 block text-sm font-medium text-zinc-700"
            >
              {content}
            </label>
          )}
          {typeof content === "object" && (
            <input
              type={content.type}
              placeholder={content.content}
              className="ml-3 w-2/5 rounded border border-solid border-zinc-400 p-1 font-normal placeholder:text-zinc-400 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
              onChange={handleInputChange(j)}
              value={inputObj[j] || ""}
            />
          )}
        </div>
      ))}
    </fieldset>
  );
};
export const CheckboxInputGroup = ({ option, onChange, index, value }) => {
  const [selectList, setSelect] = useState(null);
  const [inputObj, setObj] = useState({});

  const handleChange = (j) => (e) => {
    if (selectList[j]) {
      const tmp = [...selectList];
      tmp.splice(j, 1, false);
      if (inputObj[j] && typeof option[j].content === "object") {
        setObj({ ...inputObj, [j]: "" });
      }
      setSelect(tmp);
    } else {
      const tmp = [...selectList];
      tmp.splice(j, 1, true);
      setSelect(tmp);
    }
  };

  const handleInputChange = (j) => (e) => {
    setObj({ ...inputObj, [j]: e.target.value });
  };

  useUpdateEffect(() => {
    const valueList = selectList.reduce((ac, v, i) => {
      if (v && inputObj[i]) return [...ac, inputObj[i]];
      return ac;
    }, []);
    if (onChange) {
      onChange(index, valueList);
    }
  }, [selectList, inputObj]);

  useEffect(() => {
    if (!selectList) {
      const [list, obj] = option.reduce(
        (acc, cur, i) => {
          if (typeof cur.content === "string") {
            return [
              [...acc[0], value === cur.content],
              { ...acc[1], [i]: cur.content },
            ];
          } else if (value === cur.content.content) {
            return [[...acc[0], true], { ...acc[1], [i]: value }];
          } else {
            return [[...acc[0], false], acc[1]];
          }
        },
        [[], {}]
      );
      setSelect(list);
      setObj(obj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option, value]);

  return (
    <fieldset className="flex flex-col gap-3">
      {option.map(({ content }, j) => (
        <div className="flex items-center" key={`check-${index}-${j}`}>
          <input
            id={`checkbox-${index}-${content}`}
            name={`checkbox-${index}`}
            type="checkbox"
            className="h-4 w-4 border-zinc-400 bg-white"
            onChange={handleChange(j)}
            checked={(selectList && selectList[j]) || false}
          />
          {typeof content === "string" && (
            <label
              htmlFor={`$checkbox-${index}`}
              className="ml-3 block text-sm font-medium text-zinc-700"
            >
              {content}
            </label>
          )}
          {typeof content === "object" && (
            <input
              id={`checkbox-${index}--input`}
              type={content.type}
              placeholder={content.content}
              className="ml-3 w-2/5 rounded border border-solid border-zinc-400 p-1 font-normal placeholder:text-zinc-400 max-md:w-1/2 max-sm:mr-12 max-sm:w-full"
              onChange={handleInputChange(j)}
              value={inputObj[j] || ""}
            />
          )}
        </div>
      ))}
    </fieldset>
  );
};
